var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linear/project management"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M5 6.5H10.5615",
    stroke: "#8E92BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M8 10.1873H15.2246",
    stroke: "#8E92BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M5 14.2332H10.1677",
    stroke: "#8E92BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 9V7C20 4 18.5 2 15 2H7C3.5 2 2 4 2 7V15.5C2 18.5 3.5 20.5 7 20.5H9.91419",
    stroke: "#8E92BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9993 15.3232H18.9998C20.0001 15.3232 20.0001 14.7023 20.0001 14.0814C20.0001 12.8396 19.5 12.8396 18.9998 12.8396H16.9993C16.4992 12.8396 15.999 12.8396 15.999 14.0814C15.999 15.3232 16.4992 15.3232 16.9993 15.3232Z",
    stroke: "#8E92BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3414 14.1508C21.4462 14.344 22 14.9843 22 16.721V19.3605C22 21.1202 21.5556 22 19.3333 22H16.6667C14.4444 22 14 21.1202 14 19.3605V16.721C14 15.0376 14.5226 14.3827 15.5652 14.1688",
    stroke: "#8E92BC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileManager);
export default __webpack_public_path__ + "static/media/file-manager.c1895fb759b865bbd8b5f9938c8cf6e3.svg";
export { ForwardRef as ReactComponent };